import { createClient } from '@/clients/http'

export default class PGMonolithClient {
  constructor () {
    this.client = createClient(process.env.VUE_APP_PG_REVIEWS_DOMAIN)
  }

  async getProviderPhotos (legacyPracticeId, legacyLocationId) {
    const { data } = await this.client.get(`/practices/${encodeURIComponent(legacyPracticeId)}/providers`, {
      params: { location_id: legacyLocationId }
    })
    return Array.isArray(data) ? data : []
  }

  async getReviewRouting ({ legacyPracticeId, legacyLocationId, legacyProviderId, review, ppLocation, providerHash }) {
    const params = {}
    if (legacyLocationId != null) params.location_id = legacyLocationId
    if (legacyProviderId != null) params.doctor_id = legacyProviderId
    if (review) params.review = review
    if (ppLocation) params['pp-location'] = ppLocation
    if (providerHash) params.provider = providerHash

    const { data } = await this.client.get(`/practices/${encodeURIComponent(legacyPracticeId)}/review-context`, { params })
    return data || {}
  }

  updateCampaignRecipient (campaignId, recipientId, payload) {
    return this.client.post(
      `/campaigns/${encodeURIComponent(campaignId)}/recipients/${encodeURIComponent(recipientId)}`,
      payload
    )
  }

  submitReview ({ firstName, lastName, reviewerEmail, rating, reviewType, content, legacyPracticeId, legacyLocationId, legacyProviderId, calendarBookingId }) {
    const body = {
      practice_id: legacyPracticeId,
      location_id: legacyLocationId,
      doctor_id: legacyProviderId,
      email: reviewerEmail,
      first_name: firstName || '',
      last_name: lastName || '',
      quote: content,
      // Private feedback is rating 0. The monolith private list only includes
      // rows where rating is 0; a null rating is stored and then shown nowhere.
      rating: reviewType === 'PRIVATE' ? 0 : rating
    }
    if (calendarBookingId != null) body.calendar_booking_id = calendarBookingId
    return this.client.post('/reviews', body)
  }
}
